export function IntelligenceQuestionsTab() {
  return (
    <div className="text-gray-600">
      <p>Intelligence Questions testing coming soon...</p>
    </div>
  );
}
